import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import EducationalPageComponent from '../../components/EducationalPageComponent/EducationalPageComponent';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import BrochurePageComponent from '../../components/BrochurePage/BrochurePageComponent';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';
import css from './educational.module.css';
const HeadingTextMob = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
      Inspire curiosity, 
      <br />
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>confidence</span> 
      </span>{' and growth'}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin.
      </div>
    </p>
  );
};

const HeaderText = () => {
  return (
     <p className={`${css.firstHeaderTop} ${css.hideForMob}`}>
      Inspire curiosity, 
      <br />
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>confidence</span> 
      </span> {' and growth '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin.
      </div>
    </p>
  );
};

const EducationalPage = props => {
  const { isAuthenticated, currentUser } = props;
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const pageDescription = ` Whether you teach maths or language grinds, run creative writing clubs, debating societies, chess workshops, coding classes or study skills courses — if you’re helping children or teens strengthen their minds and discover new ways to learn, we’re here to take care of the admin behind the scenes. From registrations and payments to attendee lists, parent reminders and marketing, Activity Time keeps everything organised so you can stay focused on what matters — helping every learner reach their potential.`;
  return (
    <Page>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <BrochurePageComponent
            isAuthenticated={isAuthenticated}
            isProvider={isProvider}
            headingText={<HeaderText />}
            headingTextMob={<HeadingTextMob />}
            pageName="Education"
            pageDescription={pageDescription}
            pageBannerImg={`education_bannerImg.png`}
            secondSecTitle={
              'Your admin assistant for education activities — turning timetables into time saved.'
            }
            secondSecSubTitle={
              'Education activity management software that keeps your classes organised — and your focus where it belongs: on your students.'
            }
            secondSecMainPic={'education_secondFirstImg.png'}
            secondSecLogo={'education_coachLogo.png'}
            secondSecName={'Mark'}
            secondSecNameDes={'After-School Maths Grinds'}
            secondSecDesc={`“Activity Time has transformed how I manage my grind classes. Payments, confirmations, reminders and attendance are all automated now. Parents love the convenient split payments and I have way more time to prepare lesson plans instead of late-night admin.”`}
            secondSecSub={'Let’s make education'}
            thirdSecFirstTitle={`Teach. Inspire. Challenge. We’ll handle the rest.`}
            thirdSecSecondTitle={`Stay focused on every learner — not the logistics.`}
            thirdSecFirstPic={`education_thirdFirst.png`}
            thierdSecSecondPic={`education_thirdSecond.png`}
            thirdSecParaText={`We know real progress happens in class — not in the admin.`}
            testimonialPic={`education_testimonial.png`}
            testimonialTitle={`Sarah, Irish Language Tutor`}
            testimonialDesc={`“Before Activity Time, I used to confirm every booking by text and collect payments in class. With Activity Time now it’s so easy, my part-time gig feels much more professional.”`}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <div className={css.footerWrapper}>
            <Footer hideFirstWave={true} />
          </div>
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};
const mapStateToProps = state => {
  const { currentUserListing, currentUserListingFetched, currentUser } = state.user;
  const { isAuthenticated } = state.Auth || {};

  return {
    currentUserListing,
    currentUserListingFetched,
    currentUser,
    isAuthenticated,
  };
};

export default compose(withRouter, connect(mapStateToProps), injectIntl)(EducationalPage);
